export default "__VITE_ASSET__Dp98RFWq__"